import { render } from "./MediaControl.vue?vue&type=template&id=6e4fae5c&ts=true"
import script from "./MediaControl.vue?vue&type=script&lang=ts"
export * from "./MediaControl.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\SCMQ\\project\\HTML\\mq-player-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__